@if(type !== TableColumnType.Order){
<p style="color: #868686" nz-typography [nzContent]="title | localization" nzEllipsis [nzEllipsisRows]="3"></p>
}@else { № }
